import { Box, Heading } from '@chakra-ui/react';

export const PageNotFound = () => {
  return (
    <Box>
      <Heading>Sorry, page not found.</Heading>
    </Box>
  );
};
